/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Represents a process logic step
 */
export interface LogicStepSchema {
  code?: string | null;
  id?: string | null;

  [key: string]: any | string | null | undefined;
}

export class LogicStepSchema {
  code?: string | null;
  id?: string | null;

  constructor(value: LogicStepSchema) {
    Object.entries(value ?? {}).forEach(([key, val]) => (this[key] = val));
    this.code = value?.code;
    this.id = value?.id;
  }
}
